import { render, staticRenderFns } from "./uncollapsed_assignee_list.vue.js?vue&type=template&id=3057c42d&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./uncollapsed_assignee_list.vue?vue&type=template&id=3057c42d&vue3"
import script from "./uncollapsed_assignee_list.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./uncollapsed_assignee_list.vue?vue&type=script&lang=js&vue3"
export * from "./uncollapsed_assignee_list.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./uncollapsed_assignee_list.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports